export default "{\n    \"guaranteeFasterPaymentLabel\": \"Guarantee faster payment.\",\n    \"learnMoreButtonLabel\": \"Learn more\"\n}\n"